import { DeviceSelectorController } from "./DeviceSelectorController"

export const updateDeviceTypeView = DeviceSelectorController.setView
